import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearBtn"]

  connect() {
    this.toggleClear()
  }

  toggleClear() {
    if (this.hasClearBtnTarget) {
      if (this.inputTarget.value.length > 0) {
        this.clearBtnTarget.classList.remove("hidden")
      } else {
        this.clearBtnTarget.classList.add("hidden")
      }
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.toggleClear()
    this.inputTarget.focus()

    // 폼 자동 제출 (검색 초기화)
    const form = this.inputTarget.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }
}
